import React from "react";
import styled from "styled-components";
import { BASIC_BLACK, COUPON_RED } from "../../../constants/colors";
import IconCoupon from "../../../icons/IconCoupon";
import { Button } from "../../atoms/Button";

type Props = {
  onClick: () => void;
};

export const UseAppCouponButton: React.FC<Props> = ({ onClick }) => {
  return (
    <UseAppCouponButtonContainer onClick={onClick}>
      <UseAppCouponButtonWrapper>
        <Button
          btnStyle="coupon"
          text={`ジョイフル公式\nアプリクーポンを見る`}
          size="full"
          icon={IconCoupon}
        />
      </UseAppCouponButtonWrapper>
    </UseAppCouponButtonContainer>
  );
};

const UseAppCouponButtonContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
`;

const UseAppCouponButtonWrapper = styled.div`
  max-width: 980px;
  cursor: pointer;
  background-color: ${COUPON_RED};
  color: ${BASIC_BLACK};
  margin: 0 auto 14px auto;
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  text-align: left;
  font-weight: 500;
  border-radius: 8px;
`;
